/* eslint-disable react/require-default-props */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from "react";
import { Table } from "antd";
import { Container } from "./style";

interface CustomTableProps {
  dataSource: Array<any>;
  columns: Array<any>;
  loading?: boolean;
  handleTableChange?: any;
  pagination?: any;
  onRow?: any;
}

const CustomTable = ({
  dataSource,
  columns,
  loading,
  handleTableChange,
  pagination,
  onRow,
}: CustomTableProps) => {
  return (
    <Container>
      <Table
        dataSource={dataSource}
        columns={columns}
        loading={loading}
        onChange={handleTableChange}
        pagination={pagination || false}
        onRow={onRow}
      />
    </Container>
  );
};

export default CustomTable;
